import React from "react";

export default function Telegram() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <path
        d="M40.7139 4.50158C40.5008 4.31762 40.2416 4.19527 39.9642 4.14772C39.6868 4.10017 39.4016 4.12922 39.1395 4.23174L4.30732 17.8631C3.81367 18.0551 3.39573 18.4022 3.11644 18.8523C2.83714 19.3023 2.7116 19.8309 2.75871 20.3584C2.80583 20.886 3.02305 21.384 3.37767 21.7774C3.73229 22.1708 4.20512 22.4384 4.72497 22.5399L13.7501 24.3119V34.3752C13.7484 34.9233 13.9112 35.4593 14.2177 35.9138C14.5242 36.3683 14.96 36.7202 15.4689 36.9241C15.9769 37.1315 16.5356 37.1813 17.0724 37.067C17.6091 36.9527 18.099 36.6795 18.4784 36.283L22.8303 31.7695L29.7345 37.8127C30.2326 38.2545 30.8751 38.499 31.5409 38.5002C31.8327 38.4999 32.1226 38.4541 32.4003 38.3644C32.8539 38.2204 33.262 37.9601 33.5837 37.6094C33.9055 37.2587 34.1298 36.8298 34.2342 36.3655L41.2106 6.0158C41.273 5.74209 41.2597 5.45655 41.1722 5.1898C41.0847 4.92305 40.9263 4.68514 40.7139 4.50158ZM30.2054 10.6891L14.8072 21.7166L6.28216 20.0442L30.2054 10.6891ZM16.5001 34.3752V26.2145L20.7609 29.9511L16.5001 34.3752ZM31.5444 35.7502L17.3337 23.2892L37.7869 8.63002L31.5444 35.7502Z"
        fill="#FDFEFF"
      />
    </svg>
  );
}
